import HTTP from '../../../../api/AxiosConfig';

export const getWarehousePage = (pageRequest) =>
    HTTP.post('/warehouse/warehouse-page', pageRequest);

export const save = (Record) =>
    HTTP.post('/warehouse', Record);

export const updateRecord = (record) =>
    HTTP.put('/warehouse', record);

export const deleteRecord = (id) =>
    HTTP.delete('/warehouse?id=' + id);

export const writeOffWarehouse = (id, amount, writeOffDate) =>
    HTTP.post('/warehouse/writeOff?id=' + id + '&amount=' + amount + '&date=' + writeOffDate);

export const getDayWriteOff = (date) =>
    HTTP.get('/warehouse/day-write-off?date=' + date);

export const writeOffDay = (items, writeOffDate) =>
    HTTP.post('/warehouse/day-write-off?date=' + writeOffDate, items);

export const getSoonExpiredProducts = () =>
    HTTP.get('/warehouse/soon-expired-products');
